const ID_CARD_WEIGHTS = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
const ID_CARD_CHECK_CODES = '10X98765432';

export function validateChineseIdCard(value) {
  const id = String(value || '').trim().toUpperCase();
  if (!id) return { ok: false, message: '请填写身份证号' };
  if (!/^\d{17}[\dX]$/.test(id)) {
    return { ok: false, message: '身份证号须为18位，最后一位可为数字或X' };
  }
  let sum = 0;
  for (let i = 0; i < 17; i += 1) {
    sum += parseInt(id.charAt(i), 10) * ID_CARD_WEIGHTS[i];
  }
  const expected = ID_CARD_CHECK_CODES.charAt(sum % 11);
  if (id.charAt(17) !== expected) {
    return { ok: false, message: '身份证号校验位不正确，请核对后重新填写' };
  }
  return { ok: true, normalized: id };
}

export function validateSupplierTaxNo(value) {
  const tax = String(value || '').trim().toUpperCase().replace(/\s/g, '');
  if (!tax) return { ok: false, message: '请填写税号' };
  if (/^\d{15}$/.test(tax)) {
    return { ok: true, normalized: tax };
  }
  if (tax.length === 18) {
    if (!/^[0-9A-HJ-NPQRTUWXY]{18}$/.test(tax)) {
      return {
        ok: false,
        message: '18位税号须为统一社会信用代码格式（数字与大写字母，不含 I/O/S/V/Z）'
      };
    }
    return { ok: true, normalized: tax };
  }
  if (/^\d{20}$/.test(tax)) {
    return { ok: true, normalized: tax };
  }
  return { ok: false, message: '税号须为15位数字，或18位统一社会信用代码' };
}

export function validateBankAccountNo(value) {
  const no = String(value || '').trim().replace(/\s/g, '');
  if (!no) return { ok: false, message: '请填写银行账号' };
  if (!/^\d{8,30}$/.test(no)) {
    return { ok: false, message: '银行账号须为8-30位数字' };
  }
  return { ok: true, normalized: no };
}

export function createPayeeFieldValidator(validateFn) {
  return (_, value) => {
    const result = validateFn(value);
    if (result.ok) return Promise.resolve();
    return Promise.reject(new Error(result.message));
  };
}
